import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Home from "./pages/Home";
import Riddle from "./pages/Riddle";
import Truth from "./pages/Truth"; // Import the Truth component
import "./styles/global.css";

const App: React.FC = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/riddle" element={<Riddle />} />
        <Route path="/truth" element={<Truth />} /> {/* Add the Truth route */}
      </Routes>
    </AnimatePresence>
  );
};

export default App;